module.exports = __webpack_public_path__ + "img/profile_pic_female.2965db56.svg";